import { EntityErrorBanner } from '@pesto/features/src/EntityProfile/components/EntityErrorBanner';
import { useListQuery } from '@pesto/hooks';
import { LoadingSpinner } from '@pesto/ui';
import { SmartTable } from '@pesto/ui/features/SmartTable/SmartTable';
import { useNavigate } from 'react-router-dom';

import { useListUsersQuery } from '../../__generated__/graphql/api';
import { routes } from '../../constants/routes';
import { useProgramFilterFields } from '../../hooks/useProgramFilterFields';
import { useUsersListConfig } from './hooks/useUsersListConfig';
import { toUserListItem, type UserListItem } from './toUserListItem';

export const Users = () => {
  const navigate = useNavigate();

  const { data, loadingOrReFetching, error } = useListQuery({
    queryHook: useListUsersQuery,
  });

  const { programFilterFields, programsLoading } = useProgramFilterFields();
  const { filterFields, getColumns, initialTableState } = useUsersListConfig(programFilterFields);

  const rows: UserListItem[] = (data?.listUsers?.users ?? []).map(toUserListItem);
  const totalRecords = data?.listUsers?.pagination?.totalRecords;
  const totalPages = data?.listUsers?.pagination?.totalPages;

  const handleRowClicked = (row: UserListItem) => {
    navigate(routes.users + '/' + row.id);
  };

  return (
    <main className="flex flex-1 flex-col gap-4 p-4 md:p-8">
      {error && <EntityErrorBanner message="We couldn't load users." detail={error.message} />}
      {programsLoading ? (
        <LoadingSpinner />
      ) : (
        <SmartTable
          title="Users"
          amountOfRows={totalRecords}
          rows={rows}
          columns={getColumns(handleRowClicked)}
          filterFields={filterFields}
          loading={loadingOrReFetching}
          pageCount={totalPages}
          initialState={initialTableState}
          enableDateRangeFilter
        />
      )}
    </main>
  );
};
